// extracted by mini-css-extract-plugin
module.exports = {"shareIcons":"social-icons_shareIcons__5hzt_","socialPlatform":"social-icons_socialPlatform__Im7eV"};